import { makeStyles } from "@material-ui/core/styles";

const BRACKET_COLOR = "#2DD4BF";
const BRACKET_SIZE = 44;
const BRACKET_THICKNESS = 4;
const BRACKET_OFFSET = 18;

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    inset: 0,
    zIndex: theme.zIndex.modal + 1,
    backgroundColor: "#003350",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2.5),
    boxSizing: "border-box",
    color: "#FFFFFF",
    fontFamily: "'Lato', 'Segoe UI', sans-serif",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
  },
  title: {
    fontFamily: "'Nunito Sans', 'Avenir Next', 'Segoe UI', sans-serif",
    fontSize: "1.5rem",
    fontWeight: 800,
    lineHeight: 1.3,
    color: "#FFFFFF",
    "&.MuiTypography-root": {
      fontWeight: 700,
    },
  },
  closeButton: {
    minWidth: 0,
    width: 40,
    height: 40,
    borderRadius: "50%",
    padding: 0,
    color: "#FFFFFF",
    backgroundColor: "rgba(255, 255, 255, 0.14)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.24)",
    },
  },
  viewport: {
    position: "relative",
    flex: 1,
    width: "100%",
    borderRadius: 20,
    overflow: "hidden",
    backgroundColor: "#000000",
    border: "1px solid rgba(10, 219, 219, 0.35)",
  },
  video: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  scanLine: {
    position: "absolute",
    left: 0,
    right: 0,
    height: 3,
    background: "linear-gradient(90deg, rgba(34,197,94,0) 0%, #3BE06A 50%, rgba(34,197,94,0) 100%)",
    boxShadow: "0 0 12px 2px rgba(59, 224, 106, 0.7)",
    animation: "$scan 2.4s ease-in-out infinite",
  },
  "@keyframes scan": {
    "0%": { top: "12%" },
    "50%": { top: "88%" },
    "100%": { top: "12%" },
  },
  corner: {
    position: "absolute",
    width: BRACKET_SIZE,
    height: BRACKET_SIZE,
    borderColor: BRACKET_COLOR,
    borderStyle: "solid",
    borderWidth: 0,
  },
  cornerTopLeft: {
    top: BRACKET_OFFSET,
    left: BRACKET_OFFSET,
    borderTopWidth: BRACKET_THICKNESS,
    borderLeftWidth: BRACKET_THICKNESS,
    borderTopLeftRadius: 10,
  },
  cornerTopRight: {
    top: BRACKET_OFFSET,
    right: BRACKET_OFFSET,
    borderTopWidth: BRACKET_THICKNESS,
    borderRightWidth: BRACKET_THICKNESS,
    borderTopRightRadius: 10,
  },
  cornerBottomLeft: {
    bottom: BRACKET_OFFSET,
    left: BRACKET_OFFSET,
    borderBottomWidth: BRACKET_THICKNESS,
    borderLeftWidth: BRACKET_THICKNESS,
    borderBottomLeftRadius: 10,
  },
  cornerBottomRight: {
    bottom: BRACKET_OFFSET,
    right: BRACKET_OFFSET,
    borderBottomWidth: BRACKET_THICKNESS,
    borderRightWidth: BRACKET_THICKNESS,
    borderBottomRightRadius: 10,
  },
  fallback: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    textAlign: "center",
    backgroundColor: "rgba(0, 0, 0, 0.85)",
  },
  fallbackText: {
    color: "#E5E7EB",
    fontSize: "0.95rem",
    lineHeight: 1.4,
    maxWidth: 280,
  },
  fallbackButton: {
    textTransform: "none",
    fontWeight: 700,
    borderRadius: 12,
    padding: theme.spacing(1, 2.5),
    color: "#0B1120",
    backgroundColor: "#2DD4BF",
    "&:hover": {
      backgroundColor: "#24B8A6",
    },
  },
  footer: {
    marginTop: theme.spacing(2),
    textAlign: "center",
    color: "#B9D4E1",
    fontSize: "0.95rem",
  },
}));

export default useStyles;
